import { DoqFaceSvgProps } from '../types';

const RelationshipsError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <defs>
      <clipPath id="clip0_1698_46576">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_1698_46576)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-relationships-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#FCBF4C"
        mask="url(#bottom-mask-relationships-error)"
      />

      <mask
        id="mask0_1698_46576"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1698_46576)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#1D9071"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#1D9071"
      />
      <path
        opacity="0.5"
        d="M88 240C88 235.582 91.5817 232 96 232H224C228.418 232 232 235.582 232 240V296C232 300.418 228.418 304 224 304H96C91.5817 304 88 300.418 88 296V240Z"
        fill="#1D9071"
      />
      <path
        d="M167.293 232L167.646 231.646L168 232H176C176 236.418 172.418 240 168 240C165.971 240 164.118 239.244 162.708 237.999L141.999 258.708C143.245 260.118 144 261.971 144 264C144 265.108 143.775 266.164 143.367 267.124L161.081 275.981C162.467 273.6 165.047 272 168 272C170.029 272 171.882 272.755 173.292 274L194.001 253.292C192.756 251.882 192 250.029 192 248C192 243.582 195.582 240 200 240C203.606 240 206.654 242.385 207.654 245.664L231.384 240.014L231.616 240.986L207.884 246.637C207.96 247.08 208 247.535 208 248C208 249.622 207.517 251.131 206.688 252.391L225.912 266.809C227.38 265.09 229.563 264 232 264V271.375L232.3 271.6L232 272V280C227.582 280 224 276.418 224 272C224 270.378 224.483 268.869 225.312 267.609L206.088 253.191C204.721 254.791 202.735 255.847 200.5 255.985V280.015C204.685 280.273 208 283.75 208 288C208 292.418 204.418 296 200 296C195.582 296 192 292.418 192 288C192 283.75 195.315 280.273 199.5 280.015V255.985C197.667 255.871 196.001 255.141 194.708 253.999L173.999 274.708C175.245 276.118 176 277.971 176 280C176 284.418 172.418 288 168 288C163.582 288 160 284.418 160 280C160 278.891 160.225 277.835 160.633 276.875L142.919 268.018C142.109 269.41 140.892 270.535 139.43 271.229L149.498 296.399C150.285 296.14 151.126 296 152 296C156.418 296 160 299.582 160 304H152L151.536 304.186L151.461 304H144C144 300.809 145.868 298.055 148.57 296.771L138.502 271.601C137.715 271.86 136.874 272 136 272C133.563 272 131.38 270.91 129.912 269.191L110.688 283.609C111.517 284.869 112 286.378 112 288C112 292.418 108.418 296 104 296C99.5817 296 96 292.418 96 288C96 283.582 99.5817 280 104 280C106.437 280 108.62 281.09 110.088 282.809L129.312 268.391C128.482 267.13 128 265.622 128 264C128 262.891 128.225 261.835 128.633 260.875L110.919 252.018C109.533 254.399 106.953 256 104 256C101.971 256 100.118 255.244 98.7077 253.999L88.3536 264.353L87.6465 263.646L98.0006 253.292C96.7555 251.882 96 250.029 96 248C96 243.582 99.5817 240 104 240C108.418 240 112 243.582 112 248C112 249.108 111.775 250.164 111.367 251.124L129.081 259.981C130.467 257.6 133.047 256 136 256C138.029 256 139.882 256.755 141.292 258L162.001 237.292C160.756 235.882 160 234.029 160 232H167.293Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.851 200.005C160.816 200.082 160 200.946 160 202C160 203.105 160.895 204 162 204H176.5C178.433 204 180 205.567 180 207.5C180 207.67 179.988 207.837 179.964 208.001L180 208.001C180.001 209.105 180.896 210 182 210C183.105 210 184 209.105 184 208C184 207.942 183.997 207.884 183.993 207.826L183.984 208.001C183.994 207.835 184 207.668 184 207.5C184 203.358 180.642 200 176.5 200H162L161.851 200.005Z"
        fill="#1D9071"
      />
    </g>
  </svg>
);
export { RelationshipsError };
